import newssImage1 from "../images/newss-image1.jpg";
import newssImage2 from "../images/newss-image2.jpg";
import newssImage3 from "../images/newss-image3.jpg";
export interface Blog {
  id: number;
  title: string;
  date: string;
  image: string;
  content: string;
}

export const blogsdata: Blog[] = [
  {
    id: 1,
    title: "Birthdays Decoration",
    date: "September 10, 2025",
    image: newssImage1, // ✅ direct image import
    content: "This is content for blog 1...",
  },
  {
    id: 2,
    title: "Wedding Decoration",
    date: "September 12, 2025",
    image: newssImage2, // ✅ direct image import
    content: "This is content for blog 2...",
  },
  {
    id: 3,
    title: "Corporate Event Decoration",
    date: "September 14, 2025",
    image: newssImage3, // ✅ direct image import
    content: "This is content for blog 3...",
  },
];
